import merge from '~lodash.mergewith'
import * as CoreSdk from '~@sentry/core'
import { captureUserFeedback, forceLoad, onLoad, showReportDialog, wrap } from '~@sentry/browser'
import { extraErrorDataIntegration, reportingObserverIntegration } from '~@sentry/integrations'
import { init } from '~@sentry/vue'

export { init }
export const SentrySdk = { ...CoreSdk, ...{ captureUserFeedback, forceLoad, onLoad, showReportDialog, wrap } }

/** @type {string[]} */
const DISABLED_INTEGRATION_KEYS = []

/**
 * @typedef {Parameters<typeof init>[0]} InitConfig
 * @param {import('@nuxt/types').Context} ctx
 * @return {Promise<InitConfig>}
 */
export function getConfig (ctx) {
  /** @type {InitConfig} */
  const config = {
    dsn:"https:\u002F\u002F04f3a27535274e83ac968b171be273b6@sentry.medrocket.me\u002F85",
    environment:"production",
    normalizeDepth:10,
    ignoreErrors:["Can't find variable: gmo","Unexpected token '\u003C'","expected expression, got '\u003C'","Non-Error promise rejection captured with value: Timeout","Method not found"],
    beforeSend:function(errorEvent, { originalException }) {
        const SENTRY_IGNORED_STATUS_CODES = [0, 401, 403, 404];

        // Из-за `originalException instanceof AxiosError` падают ошибки
        if (originalException instanceof Error && 'message' in originalException && 'code' in originalException) {
          const error = originalException;

          if (error.response && SENTRY_IGNORED_STATUS_CODES.includes(error.response.status)) {
            return null;
          }

          if (
          !window.navigator.onLine ||
          error.message === 'Network Error' ||
          error.code === 'ERR_NETWORK')
          {
            return null;
          }

          if (error.message === 'Request aborted' || error.code === 'ECONNABORTED') {
            return null;
          }
        }

        return errorEvent;
      },
  }

  /** @type {NonNullable<InitConfig>['integrations']} */
  const resolvedIntegrations = [
    extraErrorDataIntegration(),
    reportingObserverIntegration({ types:["crash"] }),
  ]

  config.integrations = (defaultIntegrations) => {
    return [
      ...defaultIntegrations.filter(integration => !DISABLED_INTEGRATION_KEYS.includes(integration.name)),
      ...resolvedIntegrations,
    ]
  }
  const runtimeConfigKey = "sentry"
  if (ctx.$config && runtimeConfigKey && ctx.$config[runtimeConfigKey]) {
    merge(config, ctx.$config[runtimeConfigKey].config, ctx.$config[runtimeConfigKey].clientConfig)
  }

  return config
}
